import GuestAttempts from "./GuestAttempts";

export default GuestAttempts;
